/* yc-lp.js — campaign landing page interactions
   - toggles the +/- mark on <details> accordions & FAQs
   - syncs the buy-box offer radios to the sticky bar (optional)
*/
(function () {
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList) return;
    if (d.classList.contains('yc-faq')) {
      var m = d.querySelector('.yc-faq__mk');
      if (m) m.textContent = d.open ? '\u2013' : '+';
    }
    if (d.classList.contains('yc-acc')) {
      var a = d.querySelector('.yc-acc__mk');
      if (a) a.textContent = d.open ? '\u2013' : '+';
    }
  }, true);
})();

/* Entry mode: ?cta=subscribe (or ?entry=email) shows the hero email capture instead of the direct price CTA. */
(function () {
  try {
    var p = new URLSearchParams(location.search);
    var mode = (p.get('cta') || p.get('entry') || '').toLowerCase();
    if (mode === 'subscribe' || mode === 'email') {
      document.querySelectorAll('[data-yc-hero-direct]').forEach(function (el) { el.style.display = 'none'; });
      document.querySelectorAll('[data-yc-hero-subscribe]').forEach(function (el) { el.hidden = false; });
      var sticky = document.querySelector('.yc-lp-sticky'); if (sticky) sticky.style.display = 'none';
      document.documentElement.setAttribute('data-yc-lp-mode', 'subscribe');
    }
  } catch (e) {}
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-yc-subscribe-submit]')) {
      if (window.fbq) { try { fbq('track', 'Lead', { content_name: 'lp-subscribe' }); } catch (_) {} }
    }
  }, true);
})();
